export default __webpack_public_path__ + "static/media/Trend8.71face77.svg";